import { Icon } from '@seeqdev/qomponents';
import { LegendWrapper } from '@/trend/LegendWrapper.atom';
import type { CapsuleItem } from '@/trendData/trendData.types';

type DecoratedCapsule = CapsuleItem & { childColor?: string };

interface RainbowLegendItemsIF {
  getCapsuleName: (capsule: CapsuleItem) => string;
  capsules: DecoratedCapsule[];
  title: string;
}

export const RainbowLegendItems: React.FunctionComponent<RainbowLegendItemsIF> = (props) => {
  const { getCapsuleName, capsules, title } = props;

  return (
    <LegendWrapper title={title}>
      {capsules.map((capsule) => (
        <div className="mr10 tw:whitespace-nowrap" key={capsule.id}>
          <Icon icon="fc-series" extraClassNames="pr5" type="color" color={capsule.childColor} />
          {getCapsuleName(capsule)}
        </div>
      ))}
    </LegendWrapper>
  );
};
